import { Suspense } from 'react';
import { createFileRoute, notFound } from '@tanstack/react-router';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { PromoItemZmInstitutesPage } from '@/features/promotion/pages/PromoItemZmInstitutesPage';
import { promoZmSearchSchema } from '@/features/promotion/types/promotion.types';
import { parsePositiveIdParams } from '@/utils/routeParams';

export const Route = createFileRoute('/_auth/market-promotion/adjustment/$promoItemId/$zmId')({
  parseParams: (rawParams) => {
    const params = parsePositiveIdParams(rawParams);
    if (params === null) throw notFound();
    return params;
  },
  validateSearch: promoZmSearchSchema,
  component: function MpItemZmInstitutesRoute() {
    const { promoItemId, zmId } = Route.useParams();
    const zmSearch = Route.useSearch();
    return (
      <ErrorBoundary moduleName="Market Promotion Institutes">
        <Suspense fallback={<PageLoader />}>
          <PromoItemZmInstitutesPage
            unit="marketPromotion"
            promoItemId={promoItemId}
            zmId={zmId}
            zmSearch={zmSearch}
          />
        </Suspense>
      </ErrorBoundary>
    );
  },
});
